export default "__VITE_ASSET__rQ3rE6hg__"